import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";

function SelectField({ value, setValue, label, valueArray, ...props }) {
  return (
    <FormControl className="w-full">
      <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel>
      <Select
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={value}
        label={label}
        onChange={setValue}
        {...props}
      >
        {valueArray?.map((e, i) => (
          <MenuItem value={e?.value} key={i}>{e?.title}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectField;
